import { Link, useLocation } from 'react-router-dom';

export function PreviewNav() {
  const { pathname } = useLocation();
  const variants = [
    { path: '/preview/c', label: 'C · Dossier', match: '/preview/c' },
    { path: '/preview/b', label: 'B · Chat-First', match: '/preview/b' },
  ];
  return (
    <div className="fixed top-3 left-1/2 -translate-x-1/2 z-50 bg-brand-ink/90 backdrop-blur-md rounded-pill px-2 py-1.5 flex gap-1 font-meta text-xs shadow-lg">
      {variants.map(v => {
        const active = pathname.startsWith(v.match);
        return (
          <Link
            key={v.path}
            to={v.path}
            className={`px-3 py-1.5 rounded-pill transition-colors ${
              active
                ? 'bg-white text-brand-ink font-semibold'
                : 'text-white/70 hover:text-white hover:bg-white/10'
            }`}
          >
            {v.label}
          </Link>
        );
      })}
    </div>
  );
}
